import { log } from 'log';
import { useCallback } from 'react';
import { validateGeolocation } from 'js/hooks/auth/pas';

import * as constants from '../constants';

export const useOnConnect = ({
    setShowOverlay,
    runBrowserGeolocation,
    triggerGeolocation,
    skipBrowserGeolocation,
    geolocationType
}) => {
    return useCallback(async () => {
        log('gcInfo', { event: 'connected' });

        let coordinates;

        try {
            if (!skipBrowserGeolocation) {
                coordinates = await runBrowserGeolocation();
            }
        } catch (error) {
            log('gcErr', { error });

            try {
                // report issue back to IMS so that it is visible in the event log
                const response = await validateGeolocation(null, null, null, null, null, geolocationType);
                const sessionValidationData = response.data.sessionValidationData || {};
                const sessionValidationByGeolocationData = sessionValidationData.SessionValidationByGeolocationData || [];
                const geolocationData = sessionValidationByGeolocationData[0] || {};

                await validateGeolocation(
                    null,
                    null,
                    null,
                    geolocationData.transactionId,
                    String(error?.message),
                    geolocationType
                );
            } catch (validationError) {
                // noop
                // since this is expected that validateGeolocation will throw an error
            } finally {
                // noop
            }

            if (error?.code === window.GeolocationPositionError?.PERMISSION_DENIED) {
                // player has not allowed geolocation
                setShowOverlay(false);
                return;
            }
        }

        const { latitude, longitude } = coordinates?.coords ?? {};

        await triggerGeolocation({
            latitude,
            longitude,
            reason: constants.GEOLOCATION_REASON.INITIAL_CHECK
        });
    }, [
        setShowOverlay,
        triggerGeolocation,
        runBrowserGeolocation,
        skipBrowserGeolocation,
        geolocationType
    ]);
};
